window.hoculus = window.hoculus || {};

hoculus.Utils = class {
    static setCookie(name, value, minutes) {
        var expires = "";
        if (minutes) {
            var date = new Date();
            date.setTime(date.getTime() + (minutes * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    };

    static getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    };

    static async domreadyState() {
        return await new Promise(function (resolve, reject) {
            document.onreadystatechange = () => {
                if (document.readyState === "complete") {
                    resolve(true);
                }
            };
        });
    }

    static async getScriptAsync(source, { isModule = false, isNoModule = false } = {}) {
        return await new Promise(function (resolve, reject) {
            hoculus.loadedScripts = hoculus.loadedScripts || [];
            if (hoculus.loadedScripts.includes(source) || source == "") {
                resolve(true);
            } else {
                var script = document.createElement("script");
                var prior = document.getElementsByTagName("script")[0];

                script.defer = 1;

                if (isModule) script.type = "module";
                if (isNoModule) script.noModule = 1;

                script.onload = script.onreadystatechange = function (_, isAbort) {
                    if (
                        isAbort ||
                        !script.readyState ||
                        /complete/.test(script.readyState)
                    ) {
                        script.onload = script.onreadystatechange = null;
                        script = undefined;

                        if (!isAbort) setTimeout(resolve(true), 50);
                    }
                };

                script.src = source;
                prior.parentNode.insertBefore(script, prior);
            }
        });
    }

    static async getCssAsync(source) {
        return await new Promise(function (resolve, reject) {
            hoculus.loadedStyles = hoculus.loadedStyles || [];
            if (hoculus.loadedStyles.includes(source) || source == "") {
                resolve(true);
            } else {
                var link = document.createElement("link");
                var prior = document.getElementsByTagName("link")[0] || document.getElementsByTagName("head")[0].firstChild;

                link.rel = "stylesheet";
                link.href = source;

                link.onload = link.onreadystatechange = function (_, isAbort) {
                    if (
                        isAbort ||
                        !link.readyState ||
                        /complete/.test(link.readyState)
                    ) {
                        link.onload = link.onreadystatechange = null;
                        link = undefined;

                        if (!isAbort) setTimeout(resolve(true), 50);
                    }
                };

                prior.parentNode.insertBefore(link, prior);
            }
        });
    }
};

hoculus.Utils.domreadyState().then(async () => {
    // Setting target to _blank in links starting with https://
    document.querySelectorAll('a[href^="https://"]').forEach(link => {
        // Converting links containing canossa to relative links
        const { pathname, search, hostname } = new URL(link.href);
        if (window.location.hostname === hostname) {
            link.href = pathname + search;
            return;
        }

        if (link.getAttribute('target') !== '_blank') {
            link.setAttribute('target', '_blank');
        }
    });
});
